"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDefaultSorting = exports.getSortedCategoryAndSubCategory = exports.getSortedCategory = void 0;
const types_1 = require("../types");
const getSortedCategory = (items) => {
    if (Array.isArray(items))
        return items.sort((a, b) => { var _a, _b; return ((_a = a.priority) !== null && _a !== void 0 ? _a : 1) - ((_b = b.priority) !== null && _b !== void 0 ? _b : 1); });
    return [];
};
exports.getSortedCategory = getSortedCategory;
const getSortedCategoryAndSubCategory = (items) => {
    const result = items.map((i) => {
        if (i.subCategory) {
            return Object.assign(Object.assign({}, i), { subCategory: Object.assign(Object.assign({}, i.subCategory), { items: (0, exports.getSortedCategory)(i.subCategory.items) }) });
        }
        return i;
    });
    return result;
};
exports.getSortedCategoryAndSubCategory = getSortedCategoryAndSubCategory;
const getDefaultSorting = (defaultSorting) => {
    const options = Object.keys(types_1.CategorySorting);
    if (defaultSorting && options.includes(defaultSorting))
        return types_1.CategorySorting[defaultSorting];
    return types_1.CategorySorting.RECOMMENDED;
};
exports.getDefaultSorting = getDefaultSorting;
